// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"206":"2997d012","817":"6f808d80"}[chunkId] + ".js";
};